import { FaRegStar, FaStar, FaStarHalfAlt } from "react-icons/fa";

export const StarRating = ({ rating }: { rating: number }) => {
    const fullStars = Math.floor(rating);
    const halfStar = rating % 1 >= 0.5;
    const emptyStars = 5 - fullStars - (halfStar ? 1 : 0);

    return (
        <div className="flex items-center gap-0.5">
            {[...Array(fullStars)].map((_, i) => (
                <FaStar key={i} className="text-yellow-400 text-sm" />
            ))}
            {halfStar && <FaStarHalfAlt className="text-yellow-400 text-sm" />}
            {[...Array(emptyStars)].map((_, i) => (
                <FaRegStar key={i} className="text-yellow-400 text-sm" />
            ))}
        </div>
    );
};